<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入活动名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入活动名称"
          />
        </a-form-item>
        <a-form-item
          label="题库类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="changeTestPaperType"
            placeholder="请选择题库类型"
            v-decorator="[
              'testPaperType',
              { rules: [{ required: true, message: '请选择题库类型' }] },
            ]"
            :triggerChange="true"
            dictCode="test_paper_type"
          />
        </a-form-item>

        <a-form-item
          v-if="paperType === '1'"
          label="关联题目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="getSomeCreateUser"
            mode="multiple"
            id="questionBank"
            v-decorator="[
              'questions',
              { rules: [{ required: true, message: '请选择关联题目' }] },
            ]"
            placeholder="请选择关联题目"
          >
            <a-select-option
              v-for="(item, index) in questionBankList"
              :value="item.id"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="随机题目数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="1"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="questionNumIndex"
            v-decorator="[
              'questionNum',
              { rules: [{ required: true, message: '请输入随机题目数量' }] },
            ]"
            placeholder="请输入随机题目数量"
            type="number"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="每日总答题次数限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="1"
            onkeyup="this.value=this.value.replace(/^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/^-1/g,'')"
            id="dayLimit"
            v-decorator="['dayTotalLimit']"
            placeholder="请输入每日答题次数限制(不输入即无限制)"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="每人总答题次数限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="1"
            onkeyup="this.value=this.value.replace(/^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/^-1/g,'')"
            id="personDayLimit"
            v-decorator="['personTotalLimit']"
            placeholder="请输入每人总答题次数限制(不输入即无限制)"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="答题频率类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="['frequencyType']"
            :triggerChange="true"
            placeholder="请选择答题频率类型"
            dictCode="prize_frequency_type"
          />
        </a-form-item>
        <a-form-item
          label="频率值(次)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="1"
            onkeyup="this.value=this.value.replace(/^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/^-1/g,'')"
            id="frequencyValue"
            v-decorator="['frequencyValue']"
            placeholder="请输入答题频率值(不输入即无限制)"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="是否发奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isAward"
            @change="changeHandler"
          />
        </a-form-item>

        <a-form-item
          v-if="isAward"
          label="达标数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="finishNumIndex"
            v-decorator="[
              'finishedNum',
              { rules: [{ required: true, message: '达标数量' }] },
            ]"
            placeholder="达标数量"
            type="number"
          ></a-input>
        </a-form-item>

        <a-row
          v-if="isAward"
          v-for="(item, index) in arr1"
          :key="index"
          :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }"
        >
          <a-col :span="12">
            <a-form-item
              label="创建人"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                type="text"
                :disabled="true"
                :max-length="50"
                v-model="createUser[index]"
                placeholder="默认为当前登录管理员"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="奖品"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                @dropdownVisibleChange="getPrizes()"
                v-model="prizeLists[index]"
                placeholder="请选择奖品"
              >
                <a-select-option
                  v-for="(item, index) in prizesList"
                  :value="item.id"
                  :key="index"
                  >{{ item.prizesName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!--<a-form-item v-if="isAward" label="奖品来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select  v-decorator="['prizeSource', { rules: [{ required: true, message: '请选择奖品来源' }] }]" placeholder="请选择奖品来源" @change="prizeSourceHandle">
            <a-select-option v-if="prizeSourceList != null" v-for="(item, index) in prizeSourceList" :value="item.value" :key="index">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="isAward" label="奖品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select   v-decorator="['relevancePrize', { rules: [{ required: true, message: '请选择奖品' }] }]" placeholder="请选择奖品">
            <a-select-option v-if="prizesList != null" v-for="(item, index) in prizesList" :value="item.id" :key="index">{{item.prizesName}}</a-select-option>
          </a-select>
        </a-form-item>-->

        <!--<a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :min="0" :step="1" onkeyup="this.value=this.value.replace(/\D|^-1/g,'')" onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')" id="sortIndex" v-decorator="['sort', { rules: [{ required: true, message: '请输入排序' }] }]" placeholder="排序数字越小越靠前" type="number"></a-input>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'MarketAnswerEventModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  data() {
    return {
      autofocus: true,
      arr1: [],
      createUser: [],
      prizeLists: [],
      paperType: '2',
      questionBankList: [], //题库列表
      isAward: false, //是否发奖开关，默认关闭状态
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/marketAnswerEvent/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/marketAnswerEvent/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
        getQuestionBankList:
          process.env.VUE_APP_CMS_MARKETING + '/questionBank/all',
        getCreateUser:
          process.env.VUE_APP_CMS_MARKETING + '/questionBank/getCreateUser',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.arr1 = [];
      if (record.isAward === 1) {
        this.isAward = true;
      } else {
        this.isAward = false;
      }
      this.form.resetFields();
      this.model = Object.assign({}, record);
      if (this.model.questions) {
        var arr = this.model.questions.split(',');
        this.model.questions = arr;
      }
      if (this.model.createUser) {
        var arr = this.model.createUser.split(',');
        this.createUser = arr;
        for (let i = 0; i < arr.length; i++) {
          this.arr1.push(i);
        }
      }
      if (this.model.relevancePrize) {
        var arr = this.model.relevancePrize.split(',');
        this.prizeLists = arr;
      }
      this.getPrizesList('1');
      this.getQuestionBankList();
      this.paperType = record.testPaperType;

      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'testPaperType',
            'createUser',
            'questions',
            'questionNum',
            'dayTotalLimit',
            'personTotalLimit',
            'frequencyType',
            'frequencyValue',
            'isAward',
            'finishedNum',
            'prizeSource',
            'relevancePrize'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.isAward = that.isAward === true ? '1' : '0';
          console.log('questions', formData.questions);
          if (formData.questions){
              formData.questions = formData.questions.join(",");
            }
          // formData.questions = formData.questions.toString();
          formData.relevancePrize = this.prizeLists.toString();
          formData.createUser = this.createUser.toString();

          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'testPaperType',
          'createUser',
          'questions',
          'dayTotalLimit',
          'personTotalLimit',
          'frequencyType',
          'frequencyValue',
          'questionNum',
          'isAward',
          'finishedNum',
          'prizeSource',
          'relevancePrize'
        )
      );
    },

    changeHandler(e) {
      this.isAward = e;
      if (!this.isAward) {
        this.prizeLists = []
      }
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },

    prizeSourceHandle(e) {
      if (e === '1' || e === '2') {
        this.prizesList = [];
        this.getPrizesList(e);
        //this.showPrizeList = true;
      } else {
        this.prizesList = [];
        //this.showPrizeList = false;
      }
    },

    /**获取奖品列表*/
    getPrizes() {
      let getUrl = this.url.getPrizeList;
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          console.log(this.prizesList);
        }
      });
    },
    changeTestPaperType(e) {
      this.paperType = e;
      this.arr1 = [];
      this.createUser = [];
      this.prizeLists = [];
      if (this.paperType === '2') {
        this.getCreateUser();
      }
    },

    //获取模板列表
    getQuestionBankList() {
      getAction(this.url.getQuestionBankList).then((res) => {
        if (res.success) {
          this.questionBankList = res.result;
          console.log(this.questionBankList);
        }
      });
    },
    //获取所有题目创建人
    getCreateUser() {
      getAction(this.url.getCreateUser).then((res) => {
        if (res.success) {
          console.log('res.result', res.result);
          this.createUser = res.result;
          for (let i = 0; i < res.result.length; i++) {
            this.arr1.push(i);
          }
          console.log(this.createUser);
        }
      });
    },
    getSomeCreateUser(value) {
      let newCreateUser = [];
      this.arr1 = [];
      let questions = value.join(',');
      getAction(this.url.getCreateUser, { questions: questions }).then(
        (res) => {
          if (res.success) {
            newCreateUser = res.result;
            if (newCreateUser.length > this.createUser.length) {
              //增加创建者
              newCreateUser.forEach((item) => {
                let result = this.createUser.find((ele) => ele === item);
                if (!result) {
                  this.createUser.push(item);
                }
              });
              for (let i = 0; i < newCreateUser.length; i++) {
                this.arr1.push(i);
              }
            } else if (newCreateUser.length < this.createUser.length) {
              //减少创建者
              this.createUser.forEach((item) => {
                let result = newCreateUser.find((ele) => ele === item);
                if (!result) {
                  let index = this.createUser.indexOf(item);
                  this.createUser.splice(index, 1);
                  this.prizeLists.splice(index, 1);
                }
              });
              for (let i = 0; i < newCreateUser.length; i++) {
                this.arr1.push(i);
              }
            } else {
              //不变
              for (let i = 0; i < this.createUser.length; i++) {
                this.arr1.push(i);
              }
            }
          }
        }
      );
    },
  },
};
</script>
<style scoped>
.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  /*text-align: center;*/
  padding-top: 80px;
}

.steps-action {
  margin-top: 24px;
}
</style>
